import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { type ComponentProps } from 'react';

import { CHANNEL_ID_PAID_SEARCH } from '@/constants/channel';

import AdGroupNameMultiSelect from './AdGroupNameMultiSelect';

const KeywordGroupNameMultiSelect = ({
  ...rest
}: ComponentProps<typeof AdGroupNameMultiSelect>) => {
  return (
    <AdGroupNameMultiSelect
      {...rest}
      channelId={CHANNEL_ID_PAID_SEARCH}
      placeholder={t`Select Keyword Groups...`}
      data-testid="keyword-group-multiselect"
      notFoundContent={<Trans>No keyword groups were found...</Trans>}
    />
  );
};

export default KeywordGroupNameMultiSelect;
